import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { DirectionEnum } from "@perxis-auto/shared";
import classnames from "../../utils/classnames.js";
import Button from "../Button/Button.js";
import Icon from "../Icon/Icon.js";
import "antd/es/config-provider";
import "style-inject";
import { useProviderContext } from "../Provider/context.js";
const DealerBalloonForward = ({ id, onClick, className }) => {
  const { direction } = useProviderContext();
  const isRTL = direction === DirectionEnum.Rtl;
  const directionalIcon = useMemo(() => /* @__PURE__ */ jsx(Icon, { name: isRTL ? "back" : "forward" }), [isRTL]);
  return /* @__PURE__ */ jsx(
    Button,
    {
      type: "text",
      icon: directionalIcon,
      onClick: () => onClick(id),
      className: classnames("perxis-auto-dealer-balloon-forward", className)
    }
  );
};
export {
  DealerBalloonForward as default
};
//# sourceMappingURL=DealerBalloonForward.js.map
